import { render, staticRenderFns } from "./regTypeForm.vue?vue&type=template&id=585570ee"
import script from "./regTypeForm.vue?vue&type=script&lang=js"
export * from "./regTypeForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports